import React, { Component } from "react";
// import { connect } from "react-redux";
import cookie from "react-cookies";
import AlertPopup from "../../common/components/AlertPopup/AlertPopup";
import { handleApiCall } from "../Helpers/apiHelper";
import DetailTabDisableIcon from "../../common/images/detail-disabled-icon.svg";
import DetailTabEnableIcon from "../../common/images/detail-enabled-icon.svg";
import "./MyAccountProfile.scss";
import PhoneInput from "react-phone-input-2";
let qs = require("qs");
class Listpromo extends Component {
  constructor(props) {
    super(props);
    const { setActivePage } = props;
    this.state = {
      customerdetail: "",
      fields: {
        customer_name: "",
        email: "",
        phone: "",
        gender: "",
        phone_country: "",
        phone_code: "",
        error_customerName: false,
        error_customerName_msg: "",
        error_phone: false,
        error_phone_msg: "",
      },
      imageUrl: "",
      isMobile: window.innerWidth <= 480,
      activeTab: "edit-details",
      showEditOptions: [],
      openAlertPopup: false,
      popupTitle: "",
      alertPopupMsg: "",
    };
    this.setActivePage = setActivePage;
    if (!cookie.load("UserId")) {
      props.history.push("/");
    }
    let params = "customer_id=" + cookie.load("UserId");
    this.handleUserDetail(params);
  }

  /* To Submit the personal informartion form */
  handleFormSubmit = () => {
    try {
      const formPayload = this.state.fields;
      let phoneNo = "";
      let phoneNoCode = "";
      if (formPayload.phone) {
        let mobile = formPayload.phone;
        phoneNo = mobile.slice(2);
        phoneNoCode = mobile.slice(0, 2);
      }
      let errCount = 0;
      if (this.state.fields.error_customerName) {
        errCount++;
      }
      if (this.state.fields.error_phone) {
        errCount++;
      }
      if (errCount === 0) {
        let postObject = {
          customer_name:
            formPayload.customer_name ||
            this.state.customerdetail.customer_name,
          customer_gender:
            this.state.fields.gender ||
            this.state.customerdetail.customer_gender,
          customer_phone: phoneNo || this.state.customerdetail.customer_phone,
          customer_phone_code:
            phoneNoCode || this.state.customerdetail.customer_phone_code,
          customer_countryCode:
            formPayload.phone_country ||
            this.state.customerdetail.customer_phone_country,
          customer_email:
            formPayload.email || this.state.customerdetail.customer_email,
          customer_id: cookie.load("UserId"),
          customer_photo: this.state.imageUrl,
        };

        this.handleUpdateProfile(qs.stringify(postObject));
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Utility function to show alert messages
  showAlert = (title, message) => {
    this.setState({
      openAlertPopup: true,
      popupTitle: title,
      alertPopupMsg: message,
    });
  };

  // To update the profile detils api call
  handleUpdateProfile = async (payLoad) => {
    try {
      const response = await handleApiCall(
        "post",
        "customer/updateprofile",
        payLoad
      );

      if (response.data.status === "ok") {
        const params = `customer_id=${cookie.load("UserId")}`;
        this.handleUserDetail(params);
        this.showAlert("Updated", response.data.message);
      } else {
        const errorMsg = response.data.form_error || response.data.message;
        this.showAlert("Error", errorMsg);
      }
    } catch (err) {
      console.error("Error updating profile:", err);
      this.showAlert(
        "Error",
        "An unexpected error occurred while updating the profile."
      );
    }
    this.setState({
      fields: {
        customer_name: "",
        email: "",
        phone: "",
        gender: "",
        phone_country: "",
        phone_code: "",
      },
      showEditOptions: [],
    });
  };

  // Function for get user detals
  handleUserDetail = async (payLoad) => {
    try {
      const response = await handleApiCall(
        "get",
        `customer/customerdetail?${payLoad}`
      );

      if (response.data.status === "ok") {
        const { result_set: customerDetails } = response.data; // Destructuring the customer details

        // Gender mapping using a lookup object
        const genderLabels = {
          M: { value: "M", label: "Male" },
          F: { value: "F", label: "Female" },
          O: { value: "O", label: "Others" },
        };

        // Helper function for handling null/undefined values
        const getValue = (value, fallback = "") => (value ? value : fallback);

        // Prepare the updated fields
        const updatedFields = {
          customerdetail: customerDetails,
          imageUrl: getValue(customerDetails.customer_photo, ""),
          // fields: {
          //   customer_name: getValue(customerDetails.customer_name),
          //   email: getValue(customerDetails.customer_email),
          //   phone:
          //     getValue(customerDetails.customer_phone_code) +
          //     " " +
          //     getValue(customerDetails.customer_phone),
          //   gender: genderLabels[customerDetails.customer_gender] || {
          //     value: "",
          //     label: "Unknown",
          //   },
          //   phone_country: getValue(customerDetails.customer_phone_country),
          //   phone_code: getValue(customerDetails.customer_phone_code),
          // },
        };

        // Update state once with the necessary data
        this.setState(updatedFields);
      }
    } catch (err) {
      console.error("Error fetching user details:", err);
    }
  };

  // Open the edit option for which detail
  handleShowEditOptions = (value) => {
    this.setState((prevState) => {
      let updatedFields = { ...prevState.fields };
      const {
        customer_name,
        customer_phone,
        customer_phone_code,
        customer_gender,
      } = this.state.customerdetail;

      if (value === "name") {
        updatedFields.customer_name = customer_name;
        updatedFields.error_customerName = false;
      } else if (value === "contact") {
        updatedFields.phone = customer_phone_code + customer_phone;
        updatedFields.error_phone = false;
      } else if (value === "gender") {
        updatedFields.gender = customer_gender;
      }

      let updatedEditOptions = [...prevState.showEditOptions];
      if (updatedEditOptions.includes(value)) {
        updatedEditOptions = updatedEditOptions.filter(
          (item) => item !== value
        );
      } else {
        updatedEditOptions.push(value);
      }

      return {
        fields: updatedFields,
        showEditOptions: updatedEditOptions,
      };
    });
  };

  // Function for update phone number and phone country code
  handlePhoneChange = (phone, data) => {
    const { fields, customerdetail } = this.state;
    const dialCode = data.dialCode;
    const updatedFields = {
      ...fields,
      phone: phone,
      phone_code: dialCode,
    };
    const newPhone = phone.trim();
    const currentPhone = (customerdetail.customer_phone || "").trim();
    const currentPhoneDialCode = customerdetail.customer_phone_code;
    const newPhoneNumberOnly = newPhone.slice(dialCode.length, newPhone.length);
    const newPhoneDialCode = newPhone.slice(0, dialCode.length);

    updatedFields.error_phone = false;
    updatedFields.error_phone_msg = "";

    if (newPhone === "" || newPhoneNumberOnly === "") {
      updatedFields.error_phone = true;
      updatedFields.error_phone_msg = "Phone number is required";
    } else if (newPhoneDialCode === currentPhoneDialCode) {
      if (newPhoneNumberOnly === currentPhone) {
        updatedFields.error_phone = true;
        updatedFields.error_phone_msg =
          "You've entered your current phone number. Please provide a new one.";
      }
    }
    this.setState({
      fields: updatedFields,
      countryCode: data.countryCode,
    });
  };

  // Function for update use details
  handleFieldChange = (field, value) => {
    const { fields, customerdetail } = this.state;
    const updatedFields = { ...fields, [field]: value };
    updatedFields.error_customerName = false;
    updatedFields.error_customerName_msg = "";

    if (field === "customer_name") {
      const newName = value.trim();
      const currentName = (customerdetail.customer_name || "").trim();

      if (newName === "") {
        updatedFields.error_customerName = true;
        updatedFields.error_customerName_msg = "This field is required";
      } else if (newName === currentName) {
        updatedFields.error_customerName = true;
        updatedFields.error_customerName_msg =
          "That name is already in use. Try something new.";
      }
    }

    this.setState({
      fields: updatedFields,
    });
  };

  render() {
    return (
      <>
        <div className="profile-sec-cntnr">
          <div className="profile-sec-cntnr__tab-row">
            <div
              className={`profile-sec-cntnr__tab-row__col ${
                this.state.activeTab === "edit-details" ? "col-active" : ""
              }`}
            >
              <img
                src={
                  this.state.activeTab === "edit-details"
                    ? DetailTabEnableIcon
                    : DetailTabDisableIcon
                }
                alt="documentIcon"
              />
              <span>Edit details</span>
            </div>
          </div>
          <div className="profile-sec-cntnr__edit-row">
            <div className="profile-sec-cntnr__edit-row__col">
              <label for="name">
                {this.state.showEditOptions.includes("name")
                  ? "Change your name"
                  : "your name"}
              </label>
              {this.state.showEditOptions.includes("name") ? (
                <>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={this.state.fields.customer_name}
                    onChange={(e) =>
                      this.handleFieldChange("customer_name", e.target.value)
                    }
                    className={
                      this.state.fields.error_customerName
                        ? "input-have-err"
                        : ""
                    }
                  />
                  {this.state.fields.error_customerName && (
                    <div className="error-text">
                      <p>{this.state.fields.error_customerName_msg}</p>
                    </div>
                  )}
                  <button
                    className="btn btn--primary"
                    onClick={this.handleFormSubmit}
                  >
                    save
                  </button>
                  <button
                    className="btn btn--secondary"
                    onClick={() => this.handleShowEditOptions("name")}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <p>{this.state.customerdetail.customer_name}</p>
                  <button
                    className="btn btn--text edit-btn"
                    onClick={() => this.handleShowEditOptions("name")}
                  >
                    Edit
                  </button>
                </>
              )}
            </div>
            <div className="profile-sec-cntnr__edit-row__col">
              <label for="email">Email address</label>
              <p>{this.state.customerdetail.customer_email}</p>
            </div>
            <div className="profile-sec-cntnr__edit-row__col">
              <label>Gender</label>
              {this.state.showEditOptions.includes("gender") ? (
                <>
                  <button
                    className={`btn btn--outlined ${
                      this.state.fields.gender === "M"
                        ? "btn--outlined-active"
                        : ""
                    }`}
                    onClick={() => this.handleFieldChange("gender", "M")}
                  >
                    Male
                  </button>
                  <button
                    className={`btn btn--outlined ${
                      this.state.fields.gender === "F"
                        ? "btn--outlined-active"
                        : ""
                    }`}
                    onClick={() => this.handleFieldChange("gender", "F")}
                  >
                    Female
                  </button>
                  <button
                    className={`btn btn--outlined ${
                      this.state.fields.gender === "O"
                        ? "btn--outlined-active"
                        : ""
                    }`}
                    onClick={() => this.handleFieldChange("gender", "O")}
                  >
                    Others
                  </button>
                  <button
                    className="btn btn--primary"
                    onClick={this.handleFormSubmit}
                  >
                    save
                  </button>
                  <button
                    className="btn btn--secondary"
                    onClick={() => this.handleShowEditOptions("gender")}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <p>
                    {this.state.customerdetail.customer_gender === "M"
                      ? "Male"
                      : this.state.customerdetail.customer_gender === "F"
                      ? "Female"
                      : "Others"}
                  </p>
                  <button
                    className="btn btn--text edit-btn"
                    onClick={() => this.handleShowEditOptions("gender")}
                  >
                    Edit
                  </button>
                </>
              )}
            </div>
            <div className="profile-sec-cntnr__edit-row__col">
              <label for="mobile">Contact</label>
              {this.state.showEditOptions.includes("contact") ? (
                <>
                  <PhoneInput
                    id="mobile"
                    name="mobile"
                    value={this.state.fields.phone}
                    dialCode={this.state.customerdetail.phone_code}
                    onChange={(phone, data, event, formattedValue) =>
                      this.handlePhoneChange(phone, data)
                    }
                    className={
                      this.state.fields.error_phone
                        ? "phone-input-err"
                        : "phone-input"
                    }
                  />
                  {this.state.fields.error_phone && (
                    <div className="error-text">
                      <p>{this.state.fields.error_phone_msg}</p>
                    </div>
                  )}
                  <button
                    className="btn btn--primary"
                    onClick={this.handleFormSubmit}
                  >
                    save
                  </button>
                  <button
                    className="btn btn--secondary"
                    onClick={() => this.handleShowEditOptions("contact")}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <p>
                    {"+"}
                    {this.state.customerdetail.customer_phone_code}{" "}
                    {this.state.customerdetail.customer_phone}
                  </p>
                  <button
                    className="btn btn--text edit-btn"
                    onClick={() => this.handleShowEditOptions("contact")}
                  >
                    Edit
                  </button>
                </>
              )}
            </div>
            <div className="profile-sec-cntnr__edit-row__col">
              <label>Password</label>
              <p>********</p>
              <button
                className="btn btn--text edit-btn"
                onClick={() => this.setActivePage("settings")}
              >
                Edit
              </button>
            </div>
          </div>
        </div>
        <AlertPopup
          open={this.state.openAlertPopup}
          handleClose={() => this.setState({ openAlertPopup: false })}
          title={this.state.popupTitle}
          message={this.state.alertPopupMsg}
        />
      </>
    );
  }
}

// Map Redux state to component props
// const mapStateToProps = (state) => ({
//   customerdetail: state.auth.customerdetail,
// });

// export default connect(mapStateToProps, mapDispatchToProps)(Listpromo);
export default Listpromo;
